import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "page-header"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-header-logo"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow"
}, null, -1);
const _hoisted_4 = {
  class: "page-header-search flex-center mr-16"
};
const _hoisted_5 = {
  class: "page-header-user flex-center"
};
const _hoisted_6 = {
  class: "el-dropdown-link"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "page-header-avatar"
}, null, -1);
const _hoisted_8 = {
  class: "user-info-wrap"
};
const _hoisted_9 = {
  class: "page-header-user-name"
};
const _hoisted_10 = {
  class: "page-header-switch"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_contact_us = _resolveComponent("contact-us");
  const _component_arrow_down = _resolveComponent("arrow-down");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createVNode(_component_el_menu, {
    "default-active": _ctx.state.activeIndex,
    class: "el-menu-demo",
    mode: "horizontal",
    ellipsis: false,
    onSelect: _ctx.onSelect
  }, {
    default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_tooltip, {
      content: _ctx.state.isIsv ? '（原）ISV预设自定义' : '（原）标准运单模板、商家预设自定义区',
      placement: "bottom",
      effect: "light",
      disabled: !_ctx.state.showTooltip
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "2"
      }, {
        default: _withCtx(() => [_createTextVNode("自定义区")]),
        _: 1
      })]),
      _: 1
    }, 8, ["content", "disabled"]), _createVNode(_component_el_tooltip, {
      content: "（原）自定义模板",
      placement: "bottom",
      effect: "light",
      disabled: !_ctx.state.showTooltip
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "1"
      }, {
        default: _withCtx(() => [_createTextVNode("自定义模板")]),
        _: 1
      })]),
      _: 1
    }, 8, ["disabled"]), _createVNode(_component_el_tooltip, {
      content: _ctx.state.isIsv ? '（原）打印项' : '（原）商家预设打印项',
      placement: "bottom",
      effect: "light",
      disabled: !_ctx.state.showTooltip
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "3"
      }, {
        default: _withCtx(() => [_createTextVNode("打印项")]),
        _: 1
      })]),
      _: 1
    }, 8, ["content", "disabled"]), _createVNode(_component_el_menu_item, {
      index: "4"
    }, {
      default: _withCtx(() => [_createTextVNode("回收站")]),
      _: 1
    })]),
    _: 1
  }, 8, ["default-active", "onSelect"]), _hoisted_3, _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_select, {
    modelValue: _ctx.state.service,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.state.service = $event),
    placeholder: "请选择服务商",
    size: "default",
    onChange: _ctx.onSelectService
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.services, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])], 512), [[_vShow, _ctx.identity === '0']]), _ctx.state.showTooltip ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createVNode(_component_el_tooltip, {
    content: "云打印新功能帮助",
    effect: "light",
    "popper-class": "header-notice-tooltip",
    placement: "bottom"
  }, {
    default: _withCtx(() => [_createElementVNode("i", {
      class: "jdl-icon-notice",
      onClick: _cache[1] || (_cache[1] =
      //@ts-ignore
      (...args) => _ctx.handleOpenGuide && _ctx.handleOpenGuide(...args))
    })]),
    _: 1
  }), _createVNode(_component_contact_us)], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_dropdown, {
    onCommand: _ctx.onCommand,
    "popper-class": "page-header-popper"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        command: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.userName), 1), _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("span", null, "普通商家", 512), [[_vShow, _ctx.identity === '0']]), _withDirectives(_createElementVNode("span", null, "自研商家", 512), [[_vShow, _ctx.identity === '2']]), _withDirectives(_createElementVNode("span", null, "ISV", 512), [[_vShow, _ctx.identity === '1']]), _createElementVNode("span", {
          class: "cursor switch-button",
          onClick: _cache[2] || (_cache[2] =
          //@ts-ignore
          (...args) => _ctx.onChangeIdentity && _ctx.onChangeIdentity(...args))
        }, "切换")])])]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "handbook",
        divided: ""
      }, {
        default: _withCtx(() => [_createTextVNode("使用手册")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "logout",
        divided: ""
      }, {
        default: _withCtx(() => [_createTextVNode(" 退出登录 ")]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_hoisted_7, _createVNode(_component_el_icon, {
      class: "el-icon--right"
    }, {
      default: _withCtx(() => [_createVNode(_component_arrow_down)]),
      _: 1
    })])]),
    _: 1
  }, 8, ["onCommand"])])]);
}